var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _polygon, _path150, _path151, _path152, _path153, _path154, _path155, _path156;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 978.14 348.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b62c3c;}.cls-2{fill:#ab162b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.21,271c3.45.32,5.4,2.24,5.39,5.46a4.88,4.88,0,0,1-5,5.15c-3.21.09-5.44-1.76-5.51-5.12S490.09,271.4,493.21,271Z",
    transform: "translate(-234.46 -186.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555,276.32c-.4,3.41-2.35,5.33-5.58,5.26a4.89,4.89,0,0,1-5.05-5.12c0-3.19,1.85-5.41,5.24-5.4S554.66,273.18,555,276.32Z",
    transform: "translate(-234.46 -186.44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240,309.94c-3.59-.47-5.66-2.3-5.57-5.57s2.19-5.31,5.51-5.14a4.92,4.92,0,0,1,5,5.17C245,307.83,242.77,309.3,240,309.94Z",
    transform: "translate(-234.46 -186.44)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.7,445.47c-.47,3.24-2.23,5.37-5.54,5.25a5.28,5.28,0,0,1,.1-10.55C496.59,440.08,498.27,442.29,498.7,445.47Z",
    transform: "translate(-234.46 -186.44)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555,445.64c-.51,3.26-2.41,5.23-5.67,5.08a4.92,4.92,0,0,1-5-5.22c0-3.21,2-5.4,5.34-5.33S554.76,442.35,555,445.64Z",
    transform: "translate(-234.46 -186.44)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.5,468.24c3.24.53,5.39,2.32,5.2,5.62s-2.26,5.25-5.63,5a4.93,4.93,0,0,1-4.93-5.25C347.15,470.3,349.35,468.65,352.5,468.24Z",
    transform: "translate(-234.46 -186.44)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.68,473.85c-.6,3.17-2.33,5.3-5.7,5s-5.14-2.39-4.9-5.72a4.89,4.89,0,0,1,5.34-4.81C496.67,468.43,498.43,470.57,498.68,473.85Z",
    transform: "translate(-234.46 -186.44)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.84,468.24c3.11.59,5.3,2.23,5.09,5.63s-2.3,5.18-5.61,5a4.88,4.88,0,0,1-4.9-5.25C544.43,470.37,546.55,468.6,549.84,468.24Z",
    transform: "translate(-234.46 -186.44)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.33,270.92c3.57.53,5.51,2.45,5.38,5.7a4.91,4.91,0,0,1-5.21,5c-3.21,0-5.39-2-5.34-5.33S349.42,271.33,352.33,270.92Z",
    transform: "translate(-234.46 -186.44)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.91,276.35c-.53,3.33-2.38,5.4-5.66,5.22s-5.27-2.31-5-5.63a4.92,4.92,0,0,1,5.28-4.89C524.89,271.09,526.47,273.27,526.91,276.35Z",
    transform: "translate(-234.46 -186.44)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.07,332.66c-.54,3.32-2.25,5.4-5.6,5.28s-5.18-2.36-5-5.57a4.89,4.89,0,0,1,5.22-4.94C552.9,327.44,554.7,329.49,555.07,332.66Z",
    transform: "translate(-234.46 -186.44)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555,304.51c-.39,3.26-2.21,5.35-5.48,5.28s-5.26-2.25-5.15-5.52a4.91,4.91,0,0,1,5.12-5.06C552.8,299.19,554.66,301.2,555,304.51Z",
    transform: "translate(-234.46 -186.44)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.29,338c-3.22-.51-5.2-2.39-5.06-5.66a4.91,4.91,0,0,1,5.22-5c3.23,0,5.4,2,5.34,5.33S524.63,337.78,521.29,338Z",
    transform: "translate(-234.46 -186.44)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.43,440c3.29.47,5.4,2.3,5.28,5.57a5.29,5.29,0,0,1-10.57-.08C347.13,442.2,349.25,440.48,352.43,440Z",
    transform: "translate(-234.46 -186.44)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.9,281.69c-3.46-.43-5.51-2.24-5.42-5.53a4.82,4.82,0,0,1,5-5.09c3.3-.06,5.33,1.84,5.45,5.16S242.8,281.16,239.9,281.69Z",
    transform: "translate(-234.46 -186.44)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245,473.48c-.27,3.24-2,5.34-5.27,5.41s-5.29-2.08-5.32-5.3a4.88,4.88,0,0,1,4.94-5.22C242.63,468.23,244.59,470.13,245,473.48Z",
    transform: "translate(-234.46 -186.44)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245,445.22c-.24,3.43-2.1,5.47-5.32,5.5s-5.29-2.13-5.26-5.39a4.87,4.87,0,0,1,5-5.16C242.75,440.06,244.57,442.06,245,445.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.24,479c-3.19-.58-5.2-2.44-5-5.73a4.93,4.93,0,0,1,5.26-4.94c3.22,0,5.39,2.08,5.3,5.4S524.57,478.75,521.24,479Z",
    transform: "translate(-234.46 -186.44)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.13,270.92c3.62.54,5.49,2.44,5.34,5.72a4.82,4.82,0,0,1-5.19,4.93c-3.19,0-5.32-1.93-5.26-5.34S321.34,271.39,324.13,270.92Z",
    transform: "translate(-234.46 -186.44)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.09,338c-3.49-.16-5.52-2-5.61-5.22a5.24,5.24,0,0,1,10.46-.47C245.13,335.7,243.12,337.43,240.09,338Z",
    transform: "translate(-234.46 -186.44)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.12,411.91c3.59.25,5.69,1.9,5.8,5.22s-2,5.29-5.23,5.36a4.85,4.85,0,0,1-5.25-4.87C544.24,414.32,546.24,412.52,549.12,411.91Z",
    transform: "translate(-234.46 -186.44)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.84,411.94c3.15.52,5.11,2.39,4.93,5.67a4.88,4.88,0,0,1-5.26,4.89c-3.25,0-5.39-2.05-5.28-5.36S518.4,412.1,521.84,411.94Z",
    transform: "translate(-234.46 -186.44)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.9,191.91c-.58,3-2.17,5.21-5.58,5.06s-5.2-2.3-5.09-5.53a4.86,4.86,0,0,1,5.21-4.93C524.72,186.51,526.52,188.55,526.9,191.91Z",
    transform: "translate(-234.46 -186.44)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.86,417.15c-.59,3.45-2.37,5.48-5.7,5.33a4.84,4.84,0,0,1-5-5.12c0-3.24,1.94-5.31,5.29-5.34S357.29,414.33,357.86,417.15Z",
    transform: "translate(-234.46 -186.44)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.06,422.56c-3.12-.5-5.22-2.14-5-5.54s2.25-5.12,5.56-5c3.14.14,4.86,2.22,4.86,5.19C329.47,420.52,327.41,422.28,324.06,422.56Z",
    transform: "translate(-234.46 -186.44)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.07,299.1c3.09.68,5.2,2.28,5,5.71s-2.4,5.15-5.6,4.94c-3-.2-4.81-2.19-4.75-5.31C572.75,301.05,574.86,299.49,578.07,299.1Z",
    transform: "translate(-234.46 -186.44)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.7,417.13c-.5,3.46-2.29,5.51-5.61,5.34s-5.22-2.23-5-5.57a4.86,4.86,0,0,1,5.21-4.88C496.75,412,498.2,414.25,498.7,417.13Z",
    transform: "translate(-234.46 -186.44)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.43,253.36c-3.42-.35-5.35-2.28-5.18-5.52a4.83,4.83,0,0,1,5.18-4.9c3.39,0,5.34,2,5.34,5.23S524.67,253.2,521.43,253.36Z",
    transform: "translate(-234.46 -186.44)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.9,361c-.6,3.08-2.15,5.22-5.58,5.08s-5.22-2.29-5.08-5.48a4.81,4.81,0,0,1,5.2-4.88C524.83,355.69,526.44,357.75,526.9,361Z",
    transform: "translate(-234.46 -186.44)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.11,450.85c-3-.6-5.25-2.17-5.08-5.6s2.29-5.2,5.54-5.07a4.86,4.86,0,0,1,4.92,5.22C329.51,448.69,327.42,450.45,324.11,450.85Z",
    transform: "translate(-234.46 -186.44)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386,191.61c-.36,3.09-1.88,5.28-5.27,5.37s-5.32-2-5.39-5.23a4.84,4.84,0,0,1,4.91-5.21C383.55,186.36,385.44,188.25,386,191.61Z",
    transform: "translate(-234.46 -186.44)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.16,197.07c-3.14-.47-5.16-2.31-5-5.6s2.37-5.12,5.66-4.93a4.83,4.83,0,0,1,4.88,5.24C357.63,195,355.63,196.88,352.16,197.07Z",
    transform: "translate(-234.46 -186.44)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.32,479c-3.25-.51-5.36-2.15-5.3-5.52s2.28-5.23,5.47-5.16a4.88,4.88,0,0,1,5,5.14C329.54,476.79,327.52,478.58,324.32,479Z",
    transform: "translate(-234.46 -186.44)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.06,191.76c-.54,3.26-2.21,5.33-5.58,5.21s-5.16-2.33-5-5.53a4.83,4.83,0,0,1,5.19-4.92C552.92,186.54,554.7,188.55,555.06,191.76Z",
    transform: "translate(-234.46 -186.44)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.2,186.44c3.44.46,5.41,2.3,5.25,5.6-.14,3-2,4.95-5.11,4.94-3.32,0-5.27-1.93-5.31-5.24S321.22,186.82,324.2,186.44Z",
    transform: "translate(-234.46 -186.44)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.91,501.7c-.42,3-1.88,5.27-5.29,5.33s-5.32-2-5.38-5.21c-.05-3,1.78-5,4.91-5.16C524.52,496.46,526.27,498.41,526.91,501.7Z",
    transform: "translate(-234.46 -186.44)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.11,191.85c-.52,3.31-2.27,5.29-5.61,5.11s-5-2.36-4.87-5.62a4.75,4.75,0,0,1,5.23-4.81C412.13,186.6,413.86,188.64,414.11,191.85Z",
    transform: "translate(-234.46 -186.44)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.54,299.1c3.22.5,5.37,2.27,5.24,5.57a5.29,5.29,0,0,1-10.57-.08C516.19,301.28,518.32,299.54,521.54,299.1Z",
    transform: "translate(-234.46 -186.44)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.25,186.45c3.31.29,5.35,2.1,5.32,5.37a4.81,4.81,0,0,1-4.94,5.15c-3.34.12-5.38-1.76-5.54-5S490,186.88,493.25,186.45Z",
    transform: "translate(-234.46 -186.44)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.85,411.94c3.09.4,5.14,2.09,5.09,5.43s-2.21,5.17-5.45,5.1a4.83,4.83,0,0,1-5-5.09C234.45,414.17,236.35,412.22,239.85,411.94Z",
    transform: "translate(-234.46 -186.44)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.25,507.1c-3.18-.37-5.19-2.22-5.07-5.48s2.24-5.12,5.57-5a4.78,4.78,0,0,1,4.95,5.12C357.67,505,355.72,506.9,352.25,507.1Z",
    transform: "translate(-234.46 -186.44)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.68,445.38c.26-3.33,2.12-5.3,5.39-5.19a4.81,4.81,0,0,1,5,5.06c.09,3.41-1.92,5.39-5.1,5.45S262.86,448.75,262.68,445.38Z",
    transform: "translate(-234.46 -186.44)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.09,197c-3.54-.14-5.51-2-5.6-5.22a4.8,4.8,0,0,1,4.8-5.27c3.26-.2,5.44,1.53,5.64,4.87S243.12,196.53,240.09,197Z",
    transform: "translate(-234.46 -186.44)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.54,440c3.22.48,5.35,2.27,5.24,5.55a5.29,5.29,0,0,1-10.57-.06C516.2,442.26,518.29,440.47,521.54,440Z",
    transform: "translate(-234.46 -186.44)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.32,394.28c-3.58-.13-5.54-1.78-5.59-5.16,0-3.07,1.58-5,4.72-5.21,3.3-.2,5.38,1.47,5.59,4.84S581.33,393.86,578.32,394.28Z",
    transform: "translate(-234.46 -186.44)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M577.64,524.79c3.29.14,5.34,1.7,5.4,5.1s-1.81,5.22-5.17,5.26c-3.13,0-5-1.71-5.14-4.79C572.55,527.06,574.29,525.15,577.64,524.79Z",
    transform: "translate(-234.46 -186.44)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465,535.22c-3.24-.31-5.13-2.06-5-5.42s2.18-5.08,5.49-4.94c3.13.13,4.82,2,4.82,5.11C470.28,533.33,468.38,535,465,535.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.41,394.28c-3.31-.27-5.3-2.17-5.16-5.41s2.16-5.14,5.56-5a4.8,4.8,0,0,1,4.95,5.1C526.78,392.25,524.78,394.1,521.41,394.28Z",
    transform: "translate(-234.46 -186.44)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,388.67c-.17,3.44-1.72,5.49-5.13,5.54-3.08.05-5-1.57-5.25-4.69-.22-3.29,1.43-5.38,4.81-5.61S469.91,385.59,470.36,388.67Z",
    transform: "translate(-234.46 -186.44)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.65,383.82c3.65.23,5.57,1.91,5.56,5.28,0,3.11-1.71,5-4.82,5.1-3.3.14-5.35-1.54-5.48-4.94S292.77,384.24,295.65,383.82Z",
    transform: "translate(-234.46 -186.44)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268,394.27c-3.38-.22-5.26-1.95-5.21-5.32,0-3.09,1.75-5,4.88-5,3.31-.1,5.32,1.63,5.42,5S271.23,394,268,394.27Z",
    transform: "translate(-234.46 -186.44)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.51,524.78c3.58.18,5.58,1.77,5.6,5.18s-1.85,5.2-5.21,5.2c-3.12,0-4.91-1.74-5.08-4.84C431.65,526.92,433.54,525.21,436.51,524.78Z",
    transform: "translate(-234.46 -186.44)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.75,535.24c-3.57-.18-5.59-2-5.57-5.25s2-5.18,5.39-5.14a4.8,4.8,0,0,1,5.12,4.94C357.81,533,355.82,534.89,352.75,535.24Z",
    transform: "translate(-234.46 -186.44)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.35,417.26c-.27,3.42-2.17,5.31-5.43,5.2a4.73,4.73,0,0,1-5-5c0-3.33,1.82-5.31,5.14-5.37S470.12,414,470.35,417.26Z",
    transform: "translate(-234.46 -186.44)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.27,524.79c3.46.25,5.29,2.21,5.18,5.44a4.71,4.71,0,0,1-5.07,4.93c-3.35,0-5.32-1.81-5.34-5.14S321,525,324.27,524.79Z",
    transform: "translate(-234.46 -186.44)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.28,529.63c-.17,3.5-1.76,5.52-5.17,5.52s-5.21-1.85-5.2-5.22c0-3.11,1.74-4.91,4.86-5.07C299.16,524.69,300.89,526.56,301.28,529.63Z",
    transform: "translate(-234.46 -186.44)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268,524.79c3.24.28,5.16,2,5.07,5.36s-2.1,5.11-5.42,5c-3.13-.1-4.85-2-4.88-5C262.72,526.75,264.58,525,268,524.79Z",
    transform: "translate(-234.46 -186.44)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.08,524.8c3.12.35,5,2.18,4.85,5.49s-2.26,5-5.61,4.85A4.71,4.71,0,0,1,234.5,530C234.56,526.74,236.5,524.87,240.08,524.8Z",
    transform: "translate(-234.46 -186.44)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.78,496.59c3.27.35,5.27,2.18,5.07,5.48s-2.25,5.12-5.61,4.94a4.82,4.82,0,0,1-4.88-5.19C375.36,498.57,377.41,496.76,380.78,496.59Z",
    transform: "translate(-234.46 -186.44)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.76,496.6c3.6.12,5.63,1.88,5.7,5.14.06,3-1.59,5.06-4.75,5.26-3.33.22-5.4-1.54-5.66-4.83S320.8,497.08,323.76,496.6Z",
    transform: "translate(-234.46 -186.44)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.67,416.94c.38-3.2,2.19-5.12,5.53-4.89s5,2.31,4.83,5.64c-.19,3.16-2.27,4.82-5.23,4.77C574.54,422.4,572.75,420.39,572.67,416.94Z",
    transform: "translate(-234.46 -186.44)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,445.25c.32-3.27,2.2-5.25,5.47-5.05s5.11,2.25,4.92,5.63a4.81,4.81,0,0,1-5.18,4.88C574.61,450.69,572.79,448.66,572.65,445.25Z",
    transform: "translate(-234.46 -186.44)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.29,445.57c-.29,3.33-2.22,5.29-5.45,5.12s-5.13-2.2-4.93-5.61a4.8,4.8,0,0,1,5.15-4.9C299.32,440.19,301.13,442.21,301.29,445.57Z",
    transform: "translate(-234.46 -186.44)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,445.6c-.32,3.32-2.24,5.27-5.48,5.1a4.83,4.83,0,0,1-4.93-5.15c0-3.38,2-5.34,5.22-5.35S470.21,442.25,470.36,445.6Z",
    transform: "translate(-234.46 -186.44)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.44,225.18c-3.31-.27-5.3-2.18-5.2-5.4s2.15-5.13,5.54-5a4.77,4.77,0,0,1,5,5.07C526.78,223.08,524.81,225,521.44,225.18Z",
    transform: "translate(-234.46 -186.44)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.14,219.41c-.22,3.63-1.81,5.65-5.2,5.69s-5.21-1.88-5.21-5.21c0-3.09,1.72-4.95,4.84-5.1C580.93,214.63,582.66,216.53,583.14,219.41Z",
    transform: "translate(-234.46 -186.44)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.14,248.31c-.36,3.36-2.26,5.11-5.56,5-3.09-.14-4.84-2-4.82-5.12,0-3.33,1.86-5.25,5.24-5.19S273,245,273.14,248.31Z",
    transform: "translate(-234.46 -186.44)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.28,248.29c-.33,3.38-2.22,5.14-5.54,5-3.08-.15-4.85-2-4.83-5.1,0-3.35,1.88-5.23,5.23-5.2S301.11,245,301.28,248.29Z",
    transform: "translate(-234.46 -186.44)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.11,253.34c-3.25-.33-5.22-2.07-5.06-5.43s2.19-5.09,5.53-5c3.17.12,4.87,2.17,4.88,5.12C329.47,251.34,327.51,253.18,324.11,253.34Z",
    transform: "translate(-234.46 -186.44)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.51,253.35c-3.33-.2-5.39-2-5.33-5.27s2-5.19,5.42-5.14a4.82,4.82,0,0,1,5.09,5C357.81,251.17,355.84,253.06,352.51,253.35Z",
    transform: "translate(-234.46 -186.44)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,219.9c-.25,3.23-1.85,5.24-5.27,5.19s-5.17-2-5.12-5.32c0-3.11,1.85-4.88,5-5C468.31,214.69,470,216.57,470.36,219.9Z",
    transform: "translate(-234.46 -186.44)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.13,225.19c-3.56-.31-5.38-2.08-5.3-5.45.08-3.12,1.87-4.89,5-4.94,3.33-.06,5.27,1.7,5.31,5.1S440.14,224.89,437.13,225.19Z",
    transform: "translate(-234.46 -186.44)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.59,225.18c-3.42-.25-5.31-2.23-5.23-5.42a4.78,4.78,0,0,1,5.08-5c3.36-.06,5.38,1.83,5.41,5.11S383.87,225,380.59,225.18Z",
    transform: "translate(-234.46 -186.44)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.42,225.18c-3.3-.24-5.3-2.09-5.23-5.34s2.11-5.14,5.47-5.05a4.78,4.78,0,0,1,5,5C357.74,223,355.8,224.94,352.42,225.18Z",
    transform: "translate(-234.46 -186.44)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.15,304.54c-.27,3.31-2.16,5.3-5.38,5.22s-5.14-2.14-5-5.51a4.77,4.77,0,0,1,5-5C271,299.22,272.91,301.17,273.15,304.54Z",
    transform: "translate(-234.46 -186.44)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.28,304.17c-.06,3.45-1.86,5.53-5.09,5.59s-5.25-1.87-5.3-5.26a4.83,4.83,0,0,1,4.81-5.25C298.93,299,300.9,300.93,301.28,304.17Z",
    transform: "translate(-234.46 -186.44)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.27,219.74c-.15,3.27-1.7,5.32-5.11,5.35s-5.22-1.81-5.25-5.18c0-3.12,1.71-4.95,4.81-5.11C299.06,214.63,300.92,216.39,301.27,219.74Z",
    transform: "translate(-234.46 -186.44)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.91,225.19c-3.56-.37-5.3-2.26-5.14-5.57.14-3.1,2-4.84,5.1-4.82,3.34,0,5.23,1.86,5.19,5.23S270.95,225,267.91,225.19Z",
    transform: "translate(-234.46 -186.44)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,191.93c.25-3.55,2.12-5.46,5.39-5.38a4.73,4.73,0,0,1,5,5c.06,3.33-1.77,5.33-5.08,5.41S572.94,195,572.65,191.93Z",
    transform: "translate(-234.46 -186.44)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.34,192.09c-.4,3.2-2.22,5.11-5.56,4.86s-5-2.35-4.81-5.67c.21-3.16,2.3-4.81,5.26-4.74C468.5,186.62,470.26,188.65,470.34,192.09Z",
    transform: "translate(-234.46 -186.44)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.29,360.93c-.39,3.47-2.19,5.31-5.54,5.11s-5-2.29-4.83-5.59c.19-3.13,2.15-4.75,5.21-4.72C299.56,355.76,301.09,357.82,301.29,360.93Z",
    transform: "translate(-234.46 -186.44)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.2,191.61c-.27,3.43-2,5.41-5.33,5.34s-5.12-2.09-5-5.42a4.71,4.71,0,0,1,5-5C440.08,186.48,441.93,188.41,442.2,191.61Z",
    transform: "translate(-234.46 -186.44)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.06,366.13c-3.4-.22-5.3-1.93-5.3-5.29,0-3.11,1.74-5,4.83-5.1,3.27-.13,5.37,1.54,5.47,5S271.27,365.79,268.06,366.13Z",
    transform: "translate(-234.46 -186.44)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.69,191.64c.31-3.39,2.25-5.24,5.5-5.09a4.71,4.71,0,0,1,4.88,5.12c0,3.35-1.89,5.28-5.2,5.28S262.87,194.89,262.69,191.64Z",
    transform: "translate(-234.46 -186.44)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,473.66c-.24,3.25-2,5.3-5.31,5.21s-5.17-2.09-5.1-5.45a4.8,4.8,0,0,1,5-5C468.22,468.3,470.11,470.26,470.36,473.66Z",
    transform: "translate(-234.46 -186.44)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.78,535.22c-3.5-.18-5.38-2.15-5.33-5.35a4.75,4.75,0,0,1,5-5c3.35-.07,5.38,1.76,5.45,5.06S553,535,549.78,535.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.15,225.17c-3.18-.3-5.16-2.09-5.06-5.39s2.16-5.1,5.51-5a4.75,4.75,0,0,1,5,5.08C498.57,223.08,496.66,225,493.15,225.17Z",
    transform: "translate(-234.46 -186.44)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.88,524.8c3.18.38,5.07,2.35,4.87,5.57a4.81,4.81,0,0,1-5.24,4.81c-3.38,0-5.33-2.08-5.26-5.28S518.38,524.86,521.88,524.8Z",
    transform: "translate(-234.46 -186.44)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.48,535.22c-3.32-.14-5.36-1.85-5.38-5.17s1.94-5.19,5.29-5.22a4.76,4.76,0,0,1,5.16,4.87C498.71,532.91,496.87,534.92,493.48,535.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.84,191.67c.29-3.43,2.27-5.25,5.49-5.13a4.72,4.72,0,0,1,4.89,5.11c0,3.34-1.83,5.31-5.17,5.3S291,194.9,290.84,191.67Z",
    transform: "translate(-234.46 -186.44)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,473.64c.25-3.38,2.14-5.35,5.38-5.25a4.79,4.79,0,0,1,5,5c.06,3.36-1.85,5.36-5.1,5.45S572.88,476.91,572.65,473.64Z",
    transform: "translate(-234.46 -186.44)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.72,507.13c-3.59-.45-5.39-2.45-5.21-5.66a4.76,4.76,0,0,1,5.22-4.81c3.31.06,5.29,2,5.19,5.3S242.69,506.85,239.72,507.13Z",
    transform: "translate(-234.46 -186.44)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.28,501.67c-.17,3.26-1.75,5.33-5.14,5.34s-5.2-1.88-5.22-5.23c0-3.15,1.8-4.95,4.84-5.1C299.06,496.52,300.95,498.3,301.28,501.67Z",
    transform: "translate(-234.46 -186.44)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.65,214.73c3.26.17,5.32,1.77,5.33,5.15s-1.88,5.2-5.24,5.22c-3.15,0-5-1.82-5.1-4.85C403.49,217,405.26,215.05,408.65,214.73Z",
    transform: "translate(-234.46 -186.44)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.9,225.16c-3.54-.16-5.41-2.1-5.39-5.31a4.72,4.72,0,0,1,4.94-5.06c3.33-.1,5.38,1.67,5.48,5S243,224.86,239.9,225.16Z",
    transform: "translate(-234.46 -186.44)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.2,501.46C442,505,440.31,507,436.95,507s-5.15-2-5.12-5.31c0-3.14,1.87-4.91,4.92-5C440.08,496.55,441.84,498.45,442.2,501.46Z",
    transform: "translate(-234.46 -186.44)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.32,225.17c-3.23-.2-5.26-1.87-5.27-5.21s2-5.17,5.3-5.17a4.72,4.72,0,0,1,5.1,4.9C329.58,222.91,327.76,224.89,324.32,225.17Z",
    transform: "translate(-234.46 -186.44)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.87,496.6c3.24.37,5.24,2.16,5,5.49s-2.26,5.09-5.6,4.93a4.78,4.78,0,0,1-4.86-5.19C544.47,498.58,546.48,496.75,549.87,496.6Z",
    transform: "translate(-234.46 -186.44)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.76,355.67c3.24.25,5.26,2,5.17,5.31s-2.09,5.14-5.43,5.07a4.74,4.74,0,0,1-5-5C234.43,357.8,236.35,355.9,239.76,355.67Z",
    transform: "translate(-234.46 -186.44)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.62,394.28c-3.41-.27-5.29-2.25-5.17-5.46a4.76,4.76,0,0,1,5.1-4.93c3.35,0,5.33,1.87,5.35,5.16S552.89,394.09,549.62,394.28Z",
    transform: "translate(-234.46 -186.44)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,332.74c.23-3.43,2.15-5.36,5.38-5.28a4.76,4.76,0,0,1,5,5c.06,3.35-1.81,5.35-5.09,5.43S572.9,336,572.65,332.74Z",
    transform: "translate(-234.46 -186.44)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.71,416.93c.37-3.2,2.21-5.1,5.53-4.87s5,2.31,4.82,5.65c-.2,3.17-2.28,4.82-5.23,4.76C264.57,422.39,262.77,420.4,262.71,416.93Z",
    transform: "translate(-234.46 -186.44)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.26,417c-.1,3.52-1.95,5.47-5.19,5.49-3,0-5-1.66-5.15-4.83-.15-3.33,1.59-5.4,4.9-5.57S301,413.8,301.26,417Z",
    transform: "translate(-234.46 -186.44)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.29,332.34c-.14,3.47-1.8,5.54-5.14,5.57s-5.2-1.91-5.25-5.26a4.76,4.76,0,0,1,4.85-5.19C299,327.28,300.91,329.18,301.29,332.34Z",
    transform: "translate(-234.46 -186.44)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M492.37,394.21c-3-.65-4.74-2.7-4.22-6s2.83-4.81,6.1-4.29a4.75,4.75,0,0,1,4.27,5.65C498.14,392.86,496,394.45,492.37,394.21Z",
    transform: "translate(-234.46 -186.44)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.18,383.83c3.5.13,5.47,2,5.51,5.22a4.77,4.77,0,0,1-4.89,5.15c-3.37.19-5.46-1.66-5.62-4.9S349,384.18,352.18,383.83Z",
    transform: "translate(-234.46 -186.44)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.14,332.83c-.28,3.15-2,5.15-5.35,5.09s-5.13-2.12-5-5.45a4.75,4.75,0,0,1,5-5C271,327.43,272.95,329.28,273.14,332.83Z",
    transform: "translate(-234.46 -186.44)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.91,394.26c-3.17-.35-5.06-2.18-4.85-5.5s2.29-5,5.62-4.84c3.17.18,4.83,2.24,4.78,5.2C329.4,392.37,327.43,394.19,323.91,394.26Z",
    transform: "translate(-234.46 -186.44)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,276.07c.37-3.26,2.21-5.2,5.52-5s5.06,2.3,4.86,5.65a4.76,4.76,0,0,1-5.22,4.81C574.59,281.49,572.76,279.48,572.65,276.07Z",
    transform: "translate(-234.46 -186.44)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,276.15c-.23,3.54-2.15,5.47-5.37,5.4a4.77,4.77,0,0,1-5-5c-.07-3.34,1.8-5.37,5.08-5.45S470.1,273,470.36,276.15Z",
    transform: "translate(-234.46 -186.44)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.28,276.13c-.14,3.51-2.07,5.43-5.28,5.42a4.74,4.74,0,0,1-5.09-4.93c-.11-3.35,1.69-5.39,5-5.52S301,272.93,301.28,276.13Z",
    transform: "translate(-234.46 -186.44)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.14,276.19c-.19,3.51-2.16,5.39-5.35,5.36a4.75,4.75,0,0,1-5-5c-.09-3.33,1.71-5.4,5-5.47S272.85,273,273.14,276.19Z",
    transform: "translate(-234.46 -186.44)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.3,366.13c-3.26-.44-5.06-2.46-4.83-5.67a4.77,4.77,0,0,1,5.3-4.74c3.34.1,5.28,2,5.14,5.36S552.68,366,549.3,366.13Z",
    transform: "translate(-234.46 -186.44)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.46,383.82c3.47.24,5.48,2,5.47,5.28s-2,5.15-5.36,5.12a4.74,4.74,0,0,1-5.07-4.95C234.39,386,236.31,384.15,239.46,383.82Z",
    transform: "translate(-234.46 -186.44)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.55,253.35c-3.38-.34-5.26-2.3-5.09-5.53a4.77,4.77,0,0,1,5.16-4.88c3.35,0,5.29,2,5.29,5.24S552.81,253.18,549.55,253.35Z",
    transform: "translate(-234.46 -186.44)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.3,253.34c-3.24-.24-5.28-2-5.2-5.3s2.07-5.16,5.43-5.1a4.77,4.77,0,0,1,5,5C498.64,251.18,496.72,253.1,493.3,253.34Z",
    transform: "translate(-234.46 -186.44)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.92,242.88c3.13.34,5.11,2.1,5,5.41s-2.18,5.1-5.5,5a4.73,4.73,0,0,1-4.93-5.09C234.5,245,236.39,243,239.92,242.88Z",
    transform: "translate(-234.46 -186.44)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.14,473.59c-.22,3.26-2,5.29-5.27,5.28s-5.17-2-5.13-5.38a4.79,4.79,0,0,1,5-5.11C270.88,468.29,272.87,470.17,273.14,473.59Z",
    transform: "translate(-234.46 -186.44)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.27,474c-.36,3.16-2.26,5.09-5.54,4.84s-5-2.33-4.81-5.7a4.77,4.77,0,0,1,5.24-4.79C299.36,468.47,301.23,470.47,301.27,474Z",
    transform: "translate(-234.46 -186.44)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.45,214.73c3.33.11,5.42,1.78,5.46,5.11s-1.88,5.21-5.24,5.28a4.76,4.76,0,0,1-5.21-4.82C544.26,217.09,546.1,215.07,549.45,214.73Z",
    transform: "translate(-234.46 -186.44)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.78,535.22c-3.42-.24-5.22-2.12-5.13-5.41.08-3,1.85-4.91,5-5,3.33,0,5.3,1.77,5.34,5.11S412,535,408.78,535.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.15,360.82c-.43,3.49-2.19,5.37-5.54,5.23s-5-2.27-4.88-5.54c.16-3.1,2.06-4.79,5.16-4.78C581.31,355.74,582.84,357.8,583.15,360.82Z",
    transform: "translate(-234.46 -186.44)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.36,535.22c-3.31-.33-5.17-2.35-5-5.54a4.79,4.79,0,0,1,5.21-4.84c3.37,0,5.32,2,5.27,5.25S383.74,535.11,380.36,535.22Z",
    transform: "translate(-234.46 -186.44)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.65,502.19c.19-3.58,1.91-5.52,5.25-5.52,3.05,0,5,1.69,5.14,4.82.14,3.3-1.6,5.34-4.94,5.52S573,505.17,572.65,502.19Z",
    transform: "translate(-234.46 -186.44)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.33,507.1c-3.19-.29-5.24-2-5.23-5.32s2.09-5.17,5.39-5.14a4.79,4.79,0,0,1,5.09,5C498.65,504.83,496.77,506.8,493.33,507.1Z",
    transform: "translate(-234.46 -186.44)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.35,502c-.37,3.29-2.14,5.19-5.5,5s-5.06-2.28-4.88-5.57c.17-3.12,2.16-4.79,5.2-4.75C468.52,496.71,470.2,498.69,470.35,502Z",
    transform: "translate(-234.46 -186.44)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.08,501.78c-.31,3.17-1.92,5.21-5.29,5.22s-5.17-2-5.16-5.3a4.69,4.69,0,0,1,4.93-5C411.86,496.56,413.73,498.39,414.08,501.78Z",
    transform: "translate(-234.46 -186.44)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.13,501.68c-.19,3.24-1.79,5.28-5.16,5.32s-5.19-1.9-5.22-5.22a4.66,4.66,0,0,1,4.84-5.11C270.87,496.52,272.79,498.28,273.13,501.68Z",
    transform: "translate(-234.46 -186.44)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M577.84,242.87c3.23.28,5.21,1.93,5.19,5.3s-2,5.14-5.34,5.09c-3.1,0-4.9-1.87-5-5C572.65,245,574.47,243.17,577.84,242.87Z",
    transform: "translate(-234.46 -186.44)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.35,247.91c-.15,3.3-1.75,5.31-5.14,5.36-3.06,0-5-1.58-5.23-4.7-.21-3.29,1.47-5.38,4.83-5.6S470,244.62,470.35,247.91Z",
    transform: "translate(-234.46 -186.44)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.12,332.51c-.37,3.41-2.09,5.46-5.41,5.42s-5.17-2.16-5.11-5.43a4.82,4.82,0,0,1,5-5.05C411.88,327.38,413.74,329.36,414.12,332.51Z",
    transform: "translate(-234.46 -186.44)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.2,297.84H393.8L373,318.63V348l20.8,20.8H423.2L444,348V318.63Zm15.8,48.3L421.13,364H395.87L378,346.13V320.87L395.87,303h25.27L439,320.87Z",
    transform: "translate(-234.46 -186.44)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.8,408c-5.92,4.9-13.46,7.34-22.13,7.34-18.26,0-31-13.87-31-31.11,0-18.67,13.46-32.44,31.93-32.44a42.07,42.07,0,0,1,14.69,2.65l.71-3.47h3.77v17.85h-4.49c-1.73-7.55-7.24-11.93-15.1-11.93-11.73,0-19.58,10.3-19.58,25.91,0,16.42,8.87,27.44,22.14,27.44,5.92,0,12-2.24,19.07-7.45Z",
    transform: "translate(-234.46 -186.44)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M692.59,409h5.3l20.3-57.53h5.2L744.92,409h5.3v5.1H728.9V409h5.81l-5.81-16.32H708.5L703,409h5.51v5.1H692.59Zm26-43.86h-.2l-7.85,22.44h16.32Z",
    transform: "translate(-234.46 -186.44)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.42,409h8.47V360H753.18v8.36h-5.1V349.82h5.1V353h41.31v-3.16h5.1v18.56h-5.1V360H778.78v49h8.47v5.1H760.42Z",
    transform: "translate(-234.46 -186.44)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805.6,409h8.26v-50.9H805.6V353h42.74v13.26h-5.1v-8.16H823.76v22h15v-7.45h5.1V394h-5.1v-8.77h-15V409H844v-8.57h5.1v13.67H805.6Z",
    transform: "translate(-234.46 -186.44)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M857.54,409H866v-50.9h-8.47V353h27.13c20.2,0,33.76,12.65,33.76,31.52,0,16.83-10.91,29.58-30.29,29.58h-30.6Zm27.24,0c9,0,21.73-4.18,21.73-23.67,0-6.83-1.73-15.5-7.55-21.32-3.88-3.88-10.3-5.92-18.87-5.92H875.9V409Z",
    transform: "translate(-234.46 -186.44)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M920.88,409h8.36v-50.9h-8.36V353h23.87c15.3,0,20.61,8.16,20.61,16.12s-5.51,13.67-14.38,15.1v.2c9.08,2.14,12.55,7,21.22,24.58h6.22v5.1H963.83L957,400.51c-4.9-9.69-9.28-13.57-15.3-13.57h-2.55v22h8.26v5.1H920.88Zm20.3-27.13c8.36,0,13.36-4.49,13.36-12s-4.49-11.73-12.34-11.73h-3.06v23.77Z",
    transform: "translate(-234.46 -186.44)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M973,409h5.3l20.3-57.53h5.2L1025.29,409h5.3v5.1h-21.32V409h5.81l-5.81-16.32h-20.4L983.36,409h5.51v5.1H973Zm26-43.86h-.2l-7.85,22.44h16.32Z",
    transform: "translate(-234.46 -186.44)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1034.69,409h8.36v-50.9h-8.36V353h26.62v5.1h-8.37V409h21v-8.87h5.1v14h-44.37Z",
    transform: "translate(-234.46 -186.44)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633,497.9h8.47V447H633v-5.1h27.13c20.2,0,33.76,12.65,33.76,31.52,0,16.83-10.91,29.58-30.3,29.58H633Zm27.24,0c9,0,21.73-4.18,21.73-23.67,0-6.83-1.73-15.5-7.55-21.32C670.52,449,664.1,447,655.53,447h-4.18v50.9Z",
    transform: "translate(-234.46 -186.44)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M699.79,497.9h8.26V447h-8.26v-5.1h42.74v13.26h-5.1V447H718v22h15v-7.45H738v21.32h-5.1v-8.77H718V497.9h20.2v-8.57h5.1V503H699.79Z",
    transform: "translate(-234.46 -186.44)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M827.81,496.88c-5.92,4.9-13.46,7.34-22.14,7.34-18.26,0-31-13.87-31-31.11,0-18.67,13.46-32.44,31.93-32.44a42.07,42.07,0,0,1,14.69,2.65l.71-3.47h3.77v17.85h-4.49c-1.73-7.55-7.24-11.93-15.1-11.93-11.73,0-19.58,10.3-19.58,25.91,0,16.42,8.87,27.44,22.13,27.44,5.92,0,12-2.24,19.08-7.45Z",
    transform: "translate(-234.46 -186.44)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M866.16,440.67c22,0,32.95,17.44,32.95,31.83,0,16.42-12.45,31.72-32.95,31.72-22.34,0-32.95-17.44-32.95-31.83S843.82,440.67,866.16,440.67Zm0,58.45c13.67,0,21-10.2,21-26.62,0-16.93-7.65-26.73-21-26.73s-21,10.2-21,26.73C845.14,490.56,853.92,499.12,866.16,499.12Z",
    transform: "translate(-234.46 -186.44)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M902.34,497.9h8.36V447h-8.36v-5.1h23.87c15.3,0,20.61,8.16,20.61,16.12s-5.51,13.67-14.38,15.1v.2c9.08,2.14,12.55,7,21.22,24.58h6.22V503H945.29l-6.83-13.57c-4.9-9.69-9.28-13.57-15.3-13.57H920.6v22h8.26V503H902.34Zm20.3-27.13c8.36,0,13.36-4.49,13.36-12S931.52,447,923.66,447H920.6v23.77Z",
    transform: "translate(-234.46 -186.44)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M965.52,497.9H974V447h-8.47v-5.1h27.13c20.2,0,33.76,12.65,33.76,31.52,0,16.83-10.91,29.58-30.29,29.58h-30.6Zm27.24,0c9,0,21.73-4.18,21.73-23.67,0-6.83-1.73-15.5-7.55-21.32-3.88-3.88-10.3-5.92-18.87-5.92h-4.18v50.9Z",
    transform: "translate(-234.46 -186.44)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1065.89,440.67c22,0,32.95,17.44,32.95,31.83,0,16.42-12.45,31.72-32.95,31.72-22.34,0-32.95-17.44-32.95-31.83S1043.55,440.67,1065.89,440.67Zm0,58.45c13.67,0,21-10.2,21-26.62,0-16.93-7.65-26.73-21-26.73s-21,10.2-21,26.73C1044.88,490.56,1053.65,499.12,1065.89,499.12Z",
    transform: "translate(-234.46 -186.44)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1101.65,497.9h8.16V447h-8.16v-5.1h23.05c16.22,0,21.12,8.67,21.12,15,0,6.73-4.28,12-11.32,13.87v.2c11.22,1.33,16.93,7.85,16.93,15.5,0,10.1-8.06,16.52-20.61,16.52h-29.17Zm21.63-28.46c8,0,11.32-3.88,11.32-11.53,0-7.24-4-10.92-11.83-10.92h-3.06v22.44Zm4.08,28.46c9.59,0,12.85-5.92,12.85-11.53,0-5.81-3.37-11.83-15-11.83h-5.51V497.9Z",
    transform: "translate(-234.46 -186.44)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1155,497.9h5.3l20.3-57.53h5.2l21.52,57.53h5.3V503h-21.32v-5.1h5.81l-5.81-16.32h-20.4l-5.51,16.32h5.51V503H1155ZM1181,454h-.2l-7.85,22.44h16.32Z",
    transform: "translate(-234.46 -186.44)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "656.54 234.56 630.54 243.94 630.54 247.56 656.54 247.56 656.54 234.56"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M670.17,314.75a1.24,1.24,0,0,1,.94.44l2.58,2.78a20.53,20.53,0,0,1-7.15,5.33,24.48,24.48,0,0,1-10.17,1.91,23.76,23.76,0,0,1-9.38-1.79,20.63,20.63,0,0,1-7.2-5,22.7,22.7,0,0,1-4.62-7.76,29,29,0,0,1-1.64-9.95,27.94,27.94,0,0,1,1.71-9.95A22.76,22.76,0,0,1,640,283a21.49,21.49,0,0,1,7.42-5,24.69,24.69,0,0,1,9.55-1.79,23.26,23.26,0,0,1,9,1.64,22.77,22.77,0,0,1,6.9,4.46l-2.14,3a1.75,1.75,0,0,1-.52.55,1.49,1.49,0,0,1-.85.22,2.66,2.66,0,0,1-1.47-.65,22.46,22.46,0,0,0-2.28-1.46,16.95,16.95,0,0,0-8.71-2.11,17.45,17.45,0,0,0-6.8,1.29,14.84,14.84,0,0,0-5.31,3.73,17.22,17.22,0,0,0-3.47,6,23.78,23.78,0,0,0-1.24,7.94,23.15,23.15,0,0,0,1.29,8,17.66,17.66,0,0,0,3.52,5.95,14.86,14.86,0,0,0,5.26,3.7,16.73,16.73,0,0,0,6.55,1.27,27,27,0,0,0,3.87-.25,15.77,15.77,0,0,0,3.18-.79,13.37,13.37,0,0,0,2.71-1.36,19.31,19.31,0,0,0,2.5-2A1.73,1.73,0,0,1,670.17,314.75Z",
    transform: "translate(-234.46 -186.44)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M722.12,324.67h-5a2.16,2.16,0,0,1-1.41-.44,2.67,2.67,0,0,1-.8-1.11l-4.49-11.59H688.86l-4.49,11.59a2.35,2.35,0,0,1-.77,1.07,2.14,2.14,0,0,1-1.41.47h-5l19.2-48h6.57Zm-13.53-17.82-7.54-19.53q-.34-.87-.7-2t-.7-2.46a36.51,36.51,0,0,1-1.44,4.52l-7.54,19.5Z",
    transform: "translate(-234.46 -186.44)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.64,276.66a29.28,29.28,0,0,1,7.62.87,14.75,14.75,0,0,1,5.26,2.48,9.64,9.64,0,0,1,3,3.94,13.5,13.5,0,0,1,1,5.24,10.49,10.49,0,0,1-.55,3.4,10.23,10.23,0,0,1-1.66,3,11.83,11.83,0,0,1-2.8,2.53,15.32,15.32,0,0,1-4,1.83q5.29,1,8,3.77a10,10,0,0,1,2.66,7.25,13.49,13.49,0,0,1-1.12,5.56,11.91,11.91,0,0,1-3.28,4.32,15.3,15.3,0,0,1-5.31,2.8,23.92,23.92,0,0,1-7.17,1h-17v-48Zm-8.84,5.13v16.38h8.58a16.83,16.83,0,0,0,4.77-.6,9.62,9.62,0,0,0,3.35-1.67,6.56,6.56,0,0,0,2-2.6,8.57,8.57,0,0,0,.64-3.33q0-4.25-2.55-6.21t-7.91-2Zm10.39,37.72a16,16,0,0,0,4.79-.64,8.9,8.9,0,0,0,3.3-1.79,7,7,0,0,0,1.89-2.75,9.79,9.79,0,0,0,.6-3.5,7.19,7.19,0,0,0-2.65-5.88q-2.65-2.16-7.94-2.16H736.79v16.72Z",
    transform: "translate(-234.46 -186.44)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M782,324.67h-6.5v-48H782Z",
    transform: "translate(-234.46 -186.44)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M823.39,319.21v5.46H796.16v-48h6.46v42.54Z",
    transform: "translate(-234.46 -186.44)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874,300.68a27,27,0,0,1-1.71,9.82,21.77,21.77,0,0,1-4.82,7.57,21.47,21.47,0,0,1-7.49,4.87,26.11,26.11,0,0,1-9.67,1.73H832.44v-48h17.92a26.12,26.12,0,0,1,9.67,1.73,21.37,21.37,0,0,1,7.49,4.89,22,22,0,0,1,4.82,7.59A27,27,0,0,1,874,300.68Zm-6.67,0a24.1,24.1,0,0,0-1.21-7.91,16.68,16.68,0,0,0-3.42-5.9,14.59,14.59,0,0,0-5.36-3.69,18.63,18.63,0,0,0-7-1.27H838.94v37.49h11.42a18.61,18.61,0,0,0,7-1.27,14.67,14.67,0,0,0,5.36-3.67,16.5,16.5,0,0,0,3.42-5.88A24.1,24.1,0,0,0,867.38,300.68Z",
    transform: "translate(-234.46 -186.44)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M929.62,300.68a27.71,27.71,0,0,1-1.71,9.9,22.67,22.67,0,0,1-4.82,7.76,21.56,21.56,0,0,1-7.49,5,26.91,26.91,0,0,1-19.31,0,21.59,21.59,0,0,1-7.47-5,22.66,22.66,0,0,1-4.82-7.76,29.54,29.54,0,0,1,0-19.8,22.85,22.85,0,0,1,4.82-7.77,21.67,21.67,0,0,1,7.47-5.08,26.68,26.68,0,0,1,19.31,0,21.64,21.64,0,0,1,7.49,5.08,22.86,22.86,0,0,1,4.82,7.77A27.72,27.72,0,0,1,929.62,300.68Zm-6.67,0a24.4,24.4,0,0,0-1.21-7.94,16.81,16.81,0,0,0-3.42-5.95,14.84,14.84,0,0,0-5.36-3.74,19.5,19.5,0,0,0-14,0,15,15,0,0,0-5.38,3.74,16.65,16.65,0,0,0-3.43,5.95,26.68,26.68,0,0,0,0,15.86,16.67,16.67,0,0,0,3.43,5.93,14.8,14.8,0,0,0,5.38,3.72,19.74,19.74,0,0,0,14,0,14.66,14.66,0,0,0,5.36-3.72,16.83,16.83,0,0,0,3.42-5.93A24.25,24.25,0,0,0,923,300.68Z",
    transform: "translate(-234.46 -186.44)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b07a6d66cbc7ba9218943526b08991fd.svg";
export { ForwardRef as ReactComponent };